/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-01 10:46:18
 * @LastEditors: Jack Deng
 * @LastEditTime: 2023-03-13 14:55:03
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/Category/index.tsx
 */
import Detail from '@/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/PackageDetail';
import { Icon } from '@/src/tools/icon';
import { chunk } from 'lodash';
import React from 'react';
import { Button, Image, Menu, MenuItem } from 'src/components/Antd';
import Dropdown from 'src/constrains/DropdownHOC';
import ModalHoc from 'src/constrains/ModalHOC';
import { packParcel } from 'src/request/order';
import { msg } from 'src/tools/message';
import Row from './Components/Row';

import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Category = (props) => {
  const { data, title, modalOp, onUpdate, decimalPosition } = props;

  const groupOptions = (options) => {
    const _groupedAtt = chunk(options, 2);
    return _groupedAtt;
  };

  const groupedData = React.useMemo(() => {
    const _data = data.map((i) => {
      const { options } = i;
      const _o = groupOptions(options || []);
      return { ...i, options: _o };
    });
    return _data;
  }, [data]);

  return (
    <div className={css.container}>
      {title && (
        <div className={css.titleContainer}>
          <div className={css.title}>{title}</div>
        </div>
      )}

      {groupedData.map((i, index) => {
        return (
          <Card
            data={i}
            key={index}
            modalOp={modalOp}
            onUpdate={onUpdate}
            decimalPosition={decimalPosition}
          />
        );
      })}
    </div>
  );
};

const Card = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { modalOp, onUpdate, decimalPosition } = props;

  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;
  const { data } = props;
  const {
    options,
    image,
    sku,
    btns,
    dropOptions,
    uuid,
    hideViewDetail,
    onViewDetail,
    expand,
  } = data || {};

  const handleViewDetail = () => {
    setShowModal(true);
    setModalTitle(
      getI18n(
        `allOrders.orderDetail.components_category_viewdetail_setmodaltitle`,
      ),
    );
    setModalContent(
      <Detail
        onCancel={onModalCancel}
        uuid={uuid}
        decimalPosition={decimalPosition}
        onConfirm={(data) => {
          packParcel(data).then((res) => {
            onUpdate(res);
            onModalCancel();
            msg.destroy();
            msg.success(
              getI18n(
                `allOrders.orderDetail.components_category_viewdetail_detail_success`,
              ),
            );
          });
        }}
      />,
    );
  };
  return (
    <div className={css.cardContainer}>
      <div className={css.contentContainer}>
        <div className={css.imageContainer}>
          <Image className={css.image} src={image} width={57} height={57} />
        </div>
        <div className={css.skuBtnContainer}>
          <div className={css.skuContainer}>
            <div className={css.sku}>{sku}</div>
            {!hideViewDetail && (
              <div
                className={css.viewDetail}
                onClick={() =>
                  onViewDetail ? onViewDetail(data) : handleViewDetail()
                }>
                {getI18n(
                  `allOrders.orderDetail.components_category_viewdetail`,
                )}
              </div>
            )}
          </div>

          <div className={css.btnContainer}>
            {(btns || []).map((i, index) => {
              const { onClick, text, disabled } = i;
              return (
                <Button
                  key={index}
                  disabled={disabled}
                  className={css.btn}
                  type='primary'
                  onClick={onClick}>
                  {text}
                </Button>
              );
            })}
            {!!(dropOptions || []).length && (
              <DropComp
                dropdownContentProps={{
                  options: dropOptions || [], //[({ label: 'Test1' }, { label: 'Test2' })],
                }}
              />
            )}
          </div>
        </div>
      </div>
      <div className={css.listContainer}>
        {(options || []).map((option, index) => {
          return <Row options={option} key={index} />;
        })}
      </div>
      {expand}
    </div>
  );
};

const Trigger = (props) => {
  //const { triggerProps } = props;

  return (
    <div className={css.dropdownTrigger}>
      <Icon
        type='iconMore'

        // className={css.moreIcon}
        // onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};
const DropdownContent = (props) => {
  const { dropdownContentProps, onDropDownChange } = props;
  const { options } = dropdownContentProps || {};
  return (
    <div className={css.menuContainer}>
      <Menu selectedKeys={[]}>
        {(options || []).map((menu, index) => {
          const { onClick, label, key } = menu || {};
          return (
            <MenuItem
              className={css.subMenu}
              key={key || index}
              onClick={() => {
                if (onClick) onClick();
                onDropDownChange(false);
              }}>
              <React.Fragment>{label}</React.Fragment>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
const DropComp = Dropdown(Trigger, DropdownContent);
export default ModalHoc(Category, { width: 980 });
